<mat-drawer-container class="example-container">
  <mat-drawer #sideNav mode="over" opened="false" position="end">
    <div fxLayoutAlign="end">
      <a (click)="sideNav.toggle()"><img src="../assets/images/close.png" alt="close button" /></a>
    </div>
    <mat-nav-list dense>
      <a mat-list-item class="mat-list-item" routerLink="/dashboard" title="Click here to go to Dashboard"
        (click)="sideNav.toggle()">Home</a>
      <ng-container *ngFor="let module of modules">
        <a mat-list-item *ngIf="module.transform && canAccess(module)"
          [href]="isWaiver(module.moduleName) && module.isDisabled?'#': getFullUrl(module)"
          title="{{module.description}}" [className]="module.isDisabled?'disabled mat-list-item':'mat-list-item'">
          {{module.blockName | titlecase}}</a>
        <a mat-list-item *ngIf="!module.transform && canAccess(module)"
          [routerLink]="isWaiver(module.moduleName) && module.isDisabled?'#': module.url" title="{{module.description}}"
          [className]="module.isDisabled?'disabled mat-list-item':'mat-list-item'"
          (click)="sideNav.toggle()">{{module.blockName | titlecase}}</a>
      </ng-container>
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content>
    <app-loader></app-loader>
    <app-header *ngIf="showHeaderandFooter"></app-header>
    <div>
    <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="showHeaderandFooter"></app-footer>
  </mat-drawer-content>
</mat-drawer-container>
